import React from 'react';
import { Button, Chip } from '@material-ui/core';
import { GridColDef } from '@mui/x-data-grid';
import {
  diamGridSingleSelectFilterOperators,
  diamGridStringFilterOperators,
} from '../../diamGridUtils';
import { CustomChip } from '../../../userManagement/components/CustomChip';
import { IdentityStatus } from './IdentityStatus';
import { ActionsContainer } from './styles';
import { Identity, IdentityActionHandlers } from './types';

export function buildIdentityColumns({
  onAssign,
}: IdentityActionHandlers): GridColDef<Identity>[] {
  return [
    {
      field: 'name',
      headerName: 'Name',
      flex: 0.8,
      minWidth: 100,
      filterOperators: diamGridStringFilterOperators,
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1.25,
      minWidth: 160,
      filterOperators: diamGridStringFilterOperators,
      renderCell: ({ row }) => <Chip color="primary" label={row.email} />,
    },
    {
      field: 'type',
      headerName: 'Type',
      flex: 0.55,
      minWidth: 75,
      type: 'singleSelect',
      valueOptions: [
        { value: 'Human', label: 'Human' },
        { value: 'M2M', label: 'M2M' },
      ],
      filterOperators: diamGridSingleSelectFilterOperators,
      renderCell: ({ row }) => <Chip color="primary" label={row.type} />,
    },
    {
      field: 'teams',
      headerName: 'Teams',
      flex: 1.25,
      minWidth: 145,
      filterable: false,
      sortable: false,
      valueGetter: (_value, row) => row.teams.join(', '),
      renderCell: ({ row }) => row.teams.join(', '),
    },
    {
      field: 'accessCategory',
      headerName: 'Access Category',
      flex: 0.8,
      minWidth: 110,
      type: 'singleSelect',
      valueOptions: [
        { value: 'Internal', label: 'Internal' },
        { value: 'External', label: 'External' },
      ],
      filterOperators: diamGridSingleSelectFilterOperators,
      renderCell: ({ row }) => (
        <CustomChip
          isInternal={row.accessCategory.toLowerCase() === 'internal'}
          label={row.accessCategory}
          variant="outlined"
        />
      ),
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 0.75,
      minWidth: 130,
      filterable: false,
      sortable: false,
      renderCell: ({ row }) => <IdentityStatus status={row.status} />,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      align: 'center',
      cellClassName: 'actions-cell',
      filterable: false,
      getApplyQuickFilterFn: () => null,
      headerAlign: 'center',
      minWidth: 140,
      sortable: false,
      renderCell: ({ row }) => (
        <ActionsContainer>
          <Button
            aria-label={`Assign a role to ${row.name}`}
            color="primary"
            size="small"
            variant="contained"
            onClick={event => {
              event.stopPropagation();
              onAssign?.(row);
            }}
          >
            Assign
          </Button>
        </ActionsContainer>
      ),
    },
    {
      field: 'createdAt',
      headerName: 'Created at',
      getApplyQuickFilterFn: () => null,
    },
  ];
}
